<div class="page">
  <div class="container">

    <h1>Contact Us</h1>

    <p>
      If you have questions, feedback, or corrections related to information
      published on DailyCity, feel free to contact us using the form below.
    </p>

    <form
      class="contact-form"
      (ngSubmit)="sendMessage()"
      #contactForm="ngForm"
      novalidate
    >

      <div class="form-group">
        <label for="name">Name</label>
        <input
          id="name"
          type="text"
          class="form-control"
          name="name"
          [(ngModel)]="name"
          required
          placeholder="Your name"
        />
      </div>

      <div class="form-group">
        <label for="email">Email</label>
        <input
          id="email"
          type="email"
          class="form-control"
          name="email"
          [(ngModel)]="email"
          required
          placeholder="Your email address"
        />
      </div>

      <div class="form-group">
        <label for="message">Message</label>
        <textarea
          id="message"
          class="form-control"
          name="message"
          rows="5"
          [(ngModel)]="message"
          required
          placeholder="Write your message here"
        ></textarea>
      </div>

      <button
        type="submit"
        class="btn-submit"
        [disabled]="contactForm.invalid || sending"
      >
        {{ sending ? 'Sending...' : 'Submit Message' }}
      </button>

    </form>

    <!-- STATUS MESSAGES -->
    <p class="success-message" *ngIf="successMsg">
      {{ successMsg }}
    </p>

    <p class="error-message" *ngIf="errorMsg">
      {{ errorMsg }}
    </p>

    <h2>Response Time</h2>
    <p>
      We aim to respond to all genuine inquiries within a reasonable time.
      Please note that response times may vary depending on query volume.
    </p>

  </div>
</div>
